import type { ListItem } from "../../components/List/List"
import { MemoryClass } from "./MemoryClass"
import { clone } from "../Generics/Helps"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { CategoryEntity } from "../Category/CategoryEntity"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons"

export class CategoryMemory extends MemoryClass<CategoryEntity> {
  setList = (categories: CategoryEntity[]) => {
    this.listData = categories
  }

  protected cloneEntity(item: CategoryEntity): CategoryEntity {
    return new CategoryEntity({ ...item })
  }

  firstId = (): number => {
    return this.listData.length > 0 ? this.listData[0].id : 1
  }

  findByName = (name: string): CategoryEntity | null => {
    return clone(this.listData.filter((ss) => ss.name.toLowerCase() === name.toLowerCase())[0]) || null
  }

  getListCards = (all: boolean): ListItem[] => {
    const cards: ListItem[] = []

    let count = 0

    this.listData.forEach((ss) => {
      if (all || ss.status === EEnableStatusType.Active) {
        cards.push(this.getCard(ss, count))
      }
      count++
    })

    return cards
  }

  protected getItemId(item: CategoryEntity): number {
    return item.id
  }

  getCard(ss: CategoryEntity, count: number): ListItem {
    const enable = ss.status === EEnableStatusType.Active
    const hasDescription = ss.description.trim().length > 0

    return {
      isDisable: !enable,
      id: ss.id,
      title: ss.name,
      linkImage: "",
      index: count,
      dataFilter: [
        ss.name,
        ss.status.toEnableStatusTypeString(),
        ss.isDefault ? "padrão" : "personalizada",
        hasDescription ? "com descrição" : "sem descrição",
      ],
      children: (
        <div
          className={`
          rounded-2xl p-4
          transition-all duration-300
          ${enable ? "bg-gradient-to-r from-orange-50 to-white hover:shadow-lg hover:scale-[1.01]" : "bg-gray-100 opacity-70"}
        `}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-3 min-w-0 flex-1">
              <div
                className="
              w-11 h-11 flex items-center justify-center
              rounded-xl bg-orange-200 text-orange-700
              text-3xl shadow-inner
            "
              >
                {ss.icon || <FontAwesomeIcon icon={faLayerGroup} className="text-base" />}
              </div>

              <div className="flex flex-col min-w-0">
                <span className="text-base font-extrabold text-gray-900 truncate">{ss.name}</span>

                <span className="text-sm text-gray-700 mt-1 line-clamp-2">
                  {hasDescription ? ss.description.truncate(70) : "Sem descrição"}
                </span>
              </div>
            </div>

            <span
              className={`
                px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap
                ${enable ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"}
              `}
            >
              {enable ? "Ativo" : "Inativo"}
            </span>
          </div>

          <div className="border-t border-gray-200 mt-3 pt-3 flex flex-wrap gap-2">
            {ss.isDefault && (
              <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-700 font-medium">Padrão</span>
            )}

            {ss.displayOrder !== null && (
              <span className="px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-700 font-medium">
                Ordem: {ss.displayOrder}
              </span>
            )}

            {ss.icon.trim().length > 0 && ss.icon !== "🍔" && (
              <span className="px-2 py-1 text-xs rounded-full bg-amber-100 text-amber-700 font-medium">
                Ícone personalizado
              </span>
            )}
          </div>
        </div>
      ),
    }
  }
}
